// extracted by mini-css-extract-plugin
module.exports = {"logoContainer":"LoginModal_logoContainer__3wsqP","nativeLogo":"LoginModal_nativeLogo__3AkKT"};